import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import CoachDetail from "./pages/CoachDetail";
import Coaches from "./pages/Coaches";
import Dashboard from "./pages/Dashboard";
import FounderCommunity from "./pages/FounderCommunity";
import FounderFinance from "./pages/FounderFinance";
import FounderGrowth from "./pages/FounderGrowth";
import FounderJournal from "./pages/FounderJournal";
import FounderProductQuality from "./pages/FounderProductQuality";
import FounderStory from "./pages/FounderStory";
import Login from "./pages/Login";
import Moderation from "./pages/Moderation";
import Revenue from "./pages/Revenue";
import ShoutOuts from "./pages/ShoutOuts";
import SystemHealth from "./pages/SystemHealth";
import UserDetail from "./pages/UserDetail";
import Users from "./pages/Users";
import Verification from "./pages/Verification";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedAdminRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="/journal" element={<FounderJournal />} />
          <Route path="/growth" element={<FounderGrowth />} />
          <Route path="/story" element={<FounderStory />} />
          <Route path="/community" element={<FounderCommunity />} />
          <Route path="/product-quality" element={<FounderProductQuality />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:userId" element={<UserDetail />} />
          <Route path="/moderation" element={<Moderation />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/revenue" element={<Revenue />} />
          <Route path="/founder-finance" element={<FounderFinance />} />
          <Route path="/coaches" element={<Coaches />} />
          <Route path="/coaches/:coachId" element={<CoachDetail />} />
          <Route path="/shout-outs" element={<ShoutOuts />} />
          <Route path="/system-health" element={<SystemHealth />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
